module.exports = __webpack_public_path__ + "static/media/banner-slide-1.13574aeb.jpg";